import { createContext, useContext } from 'react';
const CapabilityBusContext = createContext(undefined);
export const CapabilityBusProvider = CapabilityBusContext.Provider;
export function useCapabilityBus() {
    return useContext(CapabilityBusContext);
}
//# sourceMappingURL=capability-bus-provider.js.map